<form #container class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
  <fieldset class="k-form-fieldset">
    <kendo-formfield orientation="horizontal">

      <label class="k-label">
        <img [src]="imgURL" style="object-fit: contain;" width="100px" height="100px" shape="square" />
      </label>

      <kendo-fileselect (select)="selectAvatar($event)" [showFileList]="false" formControlName="imagem"
        [multiple]="false" [restrictions]="fileRestrictions">
        <kendo-fileselect-messages select="{{ customMsgService.translate('selecionarImagem') }}"
          dropFilesHere="{{ customMsgService.translate('largueAImagemAqui') }} (máximo 1MB)">
        </kendo-fileselect-messages>
      </kendo-fileselect>

      <kendo-formerror> {{ customMsgService.translate('error') }}: {{
        customMsgService.translate('extensaoFicheiroNaoSuportada') }} </kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="pt" [text]="customMsgService.translate('pt')"> </kendo-label>
      <kendo-textbox [maxlength]="maxlength" (inputBlur)="inputBlur()" formControlName="pt" [clearButton]="true" #pt
        required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('pt') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="en" [text]="customMsgService.translate('en')"> </kendo-label>
      <kendo-textbox [maxlength]="maxlength" formControlName="en" [clearButton]="true" #en required>
      </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('en') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="fr" [text]="customMsgService.translate('fr')"> </kendo-label>
      <kendo-textbox [maxlength]="maxlength" formControlName="fr" [clearButton]="true" #fr required>
      </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('fr') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="codigo" [text]="customMsgService.translate('codigo')"> </kendo-label>
      <kendo-textbox [maxlength]="maxlength" formControlName="codigo" [clearButton]="true" #codigo required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('codigo') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="estado" [text]="customMsgService.translate('state')"> </kendo-label>
      <kendo-dropdownlist formControlName="estado" textField="description" valueField="id"
        [data]="lEstadosCentroDeCusto" #estado required>
      </kendo-dropdownlist>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('state') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

  </fieldset>

  <hr />
  <div class="k-form-buttons">
    <button kendoButton (click)="cancelChanges()">
      {{ customMsgService.translate('cancel') }}
    </button>

    <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>